/*
    Name: optionsService.js
    Author: Derek Chan
    Description: service module for Global Options serice calls
*/
import axios from 'axios';
import DomainNameAPI from '../constants/DomainNameAPI';
import Topics from '../constants/Topics';
import Constants from '../constants/Constants';
import LoginService from '../utils/login-service';
import _ from 'lodash';
import ReactDOM from 'react-dom';
//import util from 'util';

const variEnv = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef
const api_option_base_url = DomainNameAPI[variEnv].SERVICE_BASEURL;
const api_option_save_base_url = DomainNameAPI[variEnv].SAVE_SERVICE_BASEURL;
const api_option_set_delete_base_url = DomainNameAPI[variEnv].DELETE_SERVICE_BASEURL;

//getOptions function calls backend service to retrienve options, saves it to pubsub state
//argsObject = { Api, clientId, orgId, year }
export const getOptions = async (argsObject) => {
  if (_.isNil(argsObject.Api) || _.isNil(argsObject.clientId) || _.isNil(argsObject.orgId) || _.isNil(argsObject.year))
    throw new Error('getOptions call requires that Api, clientId, orgId, or year CANNOT be undefined or null');

  if (!LoginService.getTokens().isLoggedIn) {
    argsObject.Api.log('getOptions is called when user is not logged in');
    throw new Error('getOptions is called when user is not logged in');
  }

  let TARGET_SERVICE_URL;

  //if clientDescription is avail, add it to target-service-url
  if (_.isNil(argsObject.clientDescription) || _.isEmpty(argsObject.clientDescription))
    TARGET_SERVICE_URL =
      api_option_base_url +
      'orgId=' +
      argsObject.orgId +
      '&optionSetId=' +
      argsObject.optionSetId +
      '&application=' +
      argsObject.clientId +
      '&year=' +
      argsObject.year +
      '&clientDescription=' +
      '&clientMosObjList=' +
      encodeURIComponent(JSON.stringify(argsObject.clientMosObjList)) +
      '&createOptions=true';
  else
    TARGET_SERVICE_URL =
      api_option_base_url +
      'orgId=' +
      argsObject.orgId +
      '&optionSetId=' +
      argsObject.optionSetId +
      '&application=' +
      argsObject.clientId +
      '&year=' +
      argsObject.year +
      '&clientDescription=' +
      argsObject.clientDescription +
      '&clientMosObjList=' +
      encodeURIComponent(JSON.stringify(argsObject.clientMosObjList)) +
      '&createOptions=true';

  //argsObject.Api.log('calling target service:' + TARGET_SERVICE_URL);

  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });

  return axios({
    method: 'GET',
    url: TARGET_SERVICE_URL,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
  })
    .then((res) => {
      argsObject.Api.Publish(Topics.OPTIONS_USER_DATA, res.data);
      argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};

export const saveOptions = (argsObject) => {
  //console.log("debug save", argsObject);
  if (_.isNil(argsObject.Api) || _.isNil(argsObject.orgId) || _.isNil(argsObject.year) || _.isNil(argsObject.data))
    throw new Error('setOptions call requires that Api, orgId, year, or data CANNOT be undefined or null');

  //let cbSession = argsObject.Api.iam.getAuthSession();

  if (!LoginService.getTokens().isLoggedIn) {
    argsObject.Api.log('setOptions is called when user is not logged in');
    throw new Error('setOptions is called when user is not logged in');
  }
  let url;
  const TARGET_SERVICE_URL =
    api_option_save_base_url +
    'orgId=' +
    argsObject.orgId +
    '&year=' +
    argsObject.year +
    '&optionSetId=' +
    argsObject.optionSetId;
  url = TARGET_SERVICE_URL;

  //console.log("debug save call service", url, argsObject.data);
  argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: true });

  if (argsObject.live) {
    return axios({
      method: 'PUT',
      url: url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
        'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
      },
      data: JSON.stringify(argsObject.data),
    })
      .then((res) => {
        console.log('res', res);

        argsObject.Api.Publish(Topics.IS_LOADING, { isLoading: false });
        if (_.isFunction(argsObject.onComplete)) argsObject.onComplete();
      })
      .catch((error) => {
        // $('#saveBtn').button('reset');
        console.log(error);
        argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
      });
  } else {
    if (_.isFunction(argsObject.onComplete)) argsObject.onComplete();
    return Promise.resolve(true);
  }
};

export const deleteOptionSet = (argsObject) => {
  if (_.isNil(argsObject.Api) || _.isNil(argsObject.orgId) || _.isNil(argsObject.year) || _.isNil(argsObject.optionSetId) || _.isNil(argsObject.application) || _.isNil(argsObject.clientMos))
    throw new Error('deleteOptionSet call requires that Api, orgId, year, application, clientMos, or optionSetId CANNOT be undefined or null');

  //let cbSession = argsObject.Api.iam.getAuthSession();

  if (!LoginService.getTokens().isLoggedIn) {
    argsObject.Api.log('deleteOptionSet is called when user is not logged in');
    throw new Error('deleteOptionSet is called when user is not logged in');
  }
  let url;
  const TARGET_SERVICE_URL =
    api_option_set_delete_base_url +
    'orgId=' +
    argsObject.orgId +
    '&year=' +
    argsObject.year +
    '&optionSetId=' +
    argsObject.optionSetId +
    '&application=' +
    argsObject.application +
    '&clientMos=' +
    argsObject.clientMos +
    '&username=' +
    argsObject.username;
  url = TARGET_SERVICE_URL;
  let data = {
    orgId: argsObject.orgId,
    application: argsObject.application,
    optionSetId: argsObject.optionSetId,
    year: argsObject.year,
    clientMos: argsObject.clientMos,
    username: argsObject.username,
  };

  return axios({
    method: 'PUT',
    url: TARGET_SERVICE_URL,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CB-Catapult-Authentication-Token': 'CBLogin ' + LoginService.getTokens().sessionId,
      'X-CB-Catapult-Authorization-Token': LoginService.getTokens().token,
    },
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      argsObject.Api.Publish(Topics.API_ERROR, { apiError: true });
    });
};
